import { Decimal } from 'parrot-sui-sdk';
import { isSuiCoinAddress } from './is-sui-coin-address';

export const suiCoinAddressBalanceAdd = (type: string, balance: string) => {
  if (isSuiCoinAddress(type)) {
    return new Decimal(balance).sub(0.1 * 10 ** 9).toFixed(0);
  }

  return balance;
};
